import classes from './Ball.module.css';

const Ball = props => {
  return <div className={`${classes.container} ${props.class}`}></div>;
};

export default Ball;
